module.exports = __webpack_public_path__ + "static/img/processed.9b1ff84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/processed.png
// module id = jTlP
// module chunks = 1